module.exports = __webpack_public_path__ + "dist/assets/87e0f5b3dd6b2098ca02fd6b2970f60a.woff";